import yup from 'utils/yup';

const validationSchema = yup.object({
  fontFamily: yup.string().required(),
  fontStyle: yup.string().required(),
  fontWeight: yup.string().required(),
  file: yup.mixed().required('A file is required'),
});

export default validationSchema;
